<div fxLayout="column" fxLayoutWrap="wrap" style="min-width: 600px;">
  <div style="margin: 20px 0 0 0;" fxFlex.gt-sm="100" fxFlex.gt-xs="100" fxFlex="100">
    <span>Asignar turno</span>
  </div>
  <div style="margin: 10px 0 0 0;" fxFlex.gt-sm="100" fxFlex.gt-xs="100" fxFlex="100">
    <div fxLayoutWrap="wrap" fxLayout="row" fxLayoutAlign="start center" style="margin-top:10px">
      <div style="margin: 10px 0 0 0;" fxFlex.gt-sm="100" fxFlex.gt-xs="100" fxFlex="100">
        <div fxFlex.gt-sm="20" fxFlex.gt-xs="20" fxFlex="20" fxLayoutAlign="space-evenly">
          <img style="height: 60px; margin-top: 0px;" *ngIf="appointment.applicant.base64Picture"
            [src]="'data:image;base64,' + appointment.applicant.base64Picture | imagePipe" />
        </div>
        <div fxFlex.gt-sm="45" fxFlex.gt-xs="45" fxFlex="45">

          <div style="width:100%">
            Nombre y Apellido: {{appointment.applicant.firstName + ' ' + appointment.applicant.lastName}}
          </div>
          <div style="width:100%">
            {{appointment.applicant.docType}}: {{appointment.applicant.docNumber}}
          </div>

        </div>
        <div fxFlex.gt-sm="45" fxFlex.gt-xs="45" fxFlex="45">

          <div style="width:100%">
            Celular: {{appointment.phoneNumber}}
          </div>
          <div style="width:100%">
            Email: {{appointment.email}}
          </div>
        </div>
      </div>
    </div>
    <div fxLayoutWrap="wrap" fxLayout="row" fxLayoutAlign="center center" style="margin-top:60px">
      <div fxFlex.gt-sm="30" fxFlex.gt-xs="30" fxFlex="30">
        <mat-form-field fxFlex.gt-sm="80" fxFlex.gt-xs="80" fxFlex="80">
          <input matInput [matDatepicker]="picker" placeholder="Seleccionar fecha" [min]="maxDate"
            [(ngModel)]="dateFrom" (ngModelChange)="availableDays()">
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
      </div>
      <div fxFlex.gt-sm="50" fxFlex.gt-xs="50" fxFlex="50">
        <div fxFlex.gt-sm="80" fxFlex.gt-xs="80" fxFlex="80" *ngIf="numberOfPersons">
          Cantidad de ciudadanos citados: {{numberOfPersons.count}}
        </div>
      </div>
    </div>
  </div>
  <div style="margin: 20px 0 0 0; text-align: right;" fxFlex.gt-sm="100" fxFlex.gt-xs="100" fxFlex="100">
    <button (click)="assign()" mat-button color="primary">Asignar</button>
    <button (click)="closeDialog()" mat-button color="primary">Cerrar</button>
  </div>
</div>